import BillingLeadGenTable from '../BillingLeadGenTable';
import React from 'react';
import s from './s.module.less';
import ProListingsInvestment from '../ProListingsInvestment';
import { Popover, Select, Spin } from 'antd';
import useLeadGenerationInvestment from 'hooks/useLeadGenerationInvestment';
import PriceLabel from 'components/PriceLabel';

const { Option } = Select;

interface Props {
    isPractice?: boolean;
}

const MarketingInvestment = ({ isPractice = false }: Props) => {
    const [activeTab, setActiveTab] = React.useState<'lead-generation' | 'pro-listings'>('lead-generation');
    const [selectedPeriod, setSelectedPeriod] = React.useState(1);
    const [leadgenTotalInvestment, leadgenTotalInvestmentLoading, fetchLeadgenTotalInvestment] =
        useLeadGenerationInvestment(selectedPeriod, isPractice);
    const isOptionDisabled = (weeks: number): boolean => {
        return false;
        // if (!budgetInfo.createdAt) return false;

        // // 从创建时间到现在经过了多少周
        // const createdDate = new Date(budgetInfo.createdAt);
        // const now = new Date();

        // const timeDifference = now.getTime() - createdDate.getTime();
        // const oneWeekInMs = 7 * 24 * 60 * 60 * 1000;

        // const weeksSinceCreated = Math.ceil(timeDifference / oneWeekInMs);
        // return weeksSinceCreated < weeks;
    };
    const handlePeriodChange = (value: number) => {
        setSelectedPeriod(value);
    };

    return (
        <div className={s.wrap}>
            <div className={s.nav}>
                <span
                    className={activeTab === 'lead-generation' ? s.active : ''}
                    onClick={() => setActiveTab('lead-generation')}
                >
                    Lead generation
                </span>
                <span
                    className={activeTab === 'pro-listings' ? s.active : ''}
                    onClick={() => setActiveTab('pro-listings')}
                >
                    Pro-Listings
                </span>
            </div>
            <div className={`${s.tableWrap} ${activeTab === 'lead-generation' ? s.active : ''}`}>
                <div className={s.header}>
                    <div className={s.left}>
                        <h3>Lead generation investment</h3>
                    </div>
                </div>
                <div className={s.overviewSectionItem}>
                    <div className={s.h}>
                        <div className={s.hLeft}>
                            <span>Total Lead gen investment </span>
                            <Popover
                                trigger="hover"
                                content={
                                    <div className={s.pop}>
                                        Total amount you’ve spent on lead-generation fees to acquire patients through
                                        Klarity Health.
                                    </div>
                                }
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </div>
                        <div className={s.hRight}>
                            <Select
                                value={selectedPeriod}
                                onChange={(value) => setSelectedPeriod(value)}
                                className={s.select}
                                dropdownStyle={{ minWidth: '160px' }}
                            >
                                <Option value={1}>Last 1 month</Option>
                                <Option value={2}>Last 2 months</Option>
                                <Option value={3}>Last 3 months</Option>
                                <Option value={4}>Last 4 months</Option>
                                <Option value={5}>Last 5 months</Option>
                                <Option value={6}>Last 6 months</Option>
                                {/* <Option value={0}>Since you started</Option> */}
                            </Select>
                        </div>
                    </div>
                    <div className={s.priceWrap}>
                        <Spin spinning={leadgenTotalInvestmentLoading} wrapperClassName={s.price}>
                            <PriceLabel value={leadgenTotalInvestment} />
                        </Spin>

                        <span className={s.priceDesc} />
                    </div>
                    {/* <div className={s.actions}>
                                <span>Pay now</span>
                                <span>Pay later</span>
                            </div> */}
                </div>
                <BillingLeadGenTable isPractice={isPractice} />
            </div>
            <div className={`${s.tableWrap} ${activeTab === 'pro-listings' ? s.active : ''}`}>
                <ProListingsInvestment isPractice={isPractice} />
            </div>
        </div>
    );
};

export default MarketingInvestment;
